import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["refetchUrl"]

  connect() {
    const self = this
    const pageId = this.element.dataset.pageId
    const outcomeId = this.element.dataset.outcomeId
    var timeout = pageId == 'scorm-upload' ? 5000 : 500

    if (pageId === "bulk-courses") {
      setTimeout(function() {
        self.fetchBulkAssignmentProgress()
      }, timeout);
    } else {
      setTimeout(function() {
        self.reloadContent();
      }, timeout);
    }
  }

  reloadContent() {
    let url;
    if (this.hasRefetchUrlTarget) {
      url = this.refetchUrlTarget.dataset.url;
    } else {
      url = window.location.href;
    }

    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script'
    });
  }

  fetchBulkAssignmentProgress() {
    var outcomeId = this.element.dataset.outcomeId
    var companyId = this.element.dataset.companyId
    var url = `/companies/${companyId}/bulk_trainings_outcome/${outcomeId}`;

    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script'
    });
  }
}
